import { ExternalLink } from 'lucide-react';
import { Link } from 'react-router-dom';
import type { SidebarItem } from './sidebar-items';
import styles from './Sidebar.module.css';

export const SidebarNavItem = ({ item, activeItem }: { item: SidebarItem; activeItem: string }) => {
  const Icon = item.icon;
  const content = (
    <>
      <Icon strokeWidth={1.5} />
      <span>{item.label}</span>
      {item.external && <ExternalLink className={styles.externalIcon} />}
    </>
  );
  const current = activeItem === item.id ? 'page' : undefined;
  return (
    <li>
      {item.external ? (
        <a
          className={styles.item}
          href={item.to}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={item.label}
          title={item.label}>
          {content}
        </a>
      ) : (
        <Link
          className={styles.item}
          to={item.to}
          aria-label={item.label}
          title={item.label}
          aria-current={current}>
          {content}
        </Link>
      )}
    </li>
  );
};
